interface SectionItem {
  id: string
  label: string
}

/** A sticky in-page anchor nav, mirroring the marketing-site section rhythm. */
export function SectionNav({ items }: { items: SectionItem[] }) {
  return (
    <nav className="section-nav" aria-label="Sections">
      {items.map((item) => (
        <a key={item.id} className="section-nav-link" href={`#${item.id}`}>
          {item.label}
        </a>
      ))}
    </nav>
  )
}
